import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';

class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const isChunkError =
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('Loading chunk');
    if (isChunkError && typeof window !== 'undefined') {
      window.location.reload();
    } else {
      console.error(error);
    }
  }
}

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ClientSideHttpInterceptor } from './common/interceptor/client-side.interceptor';
import { UserService } from './services/user.service';
import { LoadingService } from './services/loader.service';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { WireToasterComponent } from './common/components/wire-toaster/wire-toaster.component';
import { EventIdInterceptor } from './components/schedule/interceptors/schedule.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withViewTransitions()), 
    provideClientHydration(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch()
    ),
    provideAnimations(),
    provideToastr({
      toastComponent: WireToasterComponent,
      positionClass: 'toast-below-header',
      timeOut: 2000,
      preventDuplicates: true,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientSideHttpInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    UserService,
    LoadingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EventIdInterceptor,
      multi: true
    }
  ]
};

